export default "__VITE_PUBLIC_ASSET__094a1874__"